export enum ModalType {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
